import VehicleImages, { VehicleImagesSkeleton } from "./VehicleImages";
import { getVehicleInfos } from "../../../utils/stockList.utils";
import VehicleOverview, { VehicleOverviewSkeleton } from "./VehicleOverview";

export default function VehicleInfo({ data }) {
  const vehicle = getVehicleInfos(data);

  return (
    <div className="row g-3">
      <div className="col-12">
        <VehicleImages data={vehicle} />
      </div>
      <div className="col-12">
        <VehicleOverview data={vehicle} />
      </div>
    </div>
  );
}

// skeleton
export function VehicleInfoSkeleton() {
  return (
    <div className="row g-3">
      <div className="col-12">
        <VehicleImagesSkeleton />
      </div>
      <div className="col-12">
        <VehicleOverviewSkeleton />
      </div>
    </div>
  );
}
